import TopNavigation from '@amzn/awsui-components-react/polaris/top-navigation';
import aws_logo from '../assets/aws_logo.svg';
import { useLocaleWrapper } from '../contexts/LocaleContextProvider';
import { useIntl } from 'react-intl';
import topNavigationMessages from '../i18n/TopNavigation.messages';
import styles from './TopNavigationBar.module.css';
import { getHandleLocaleChange, getLocaleItems } from '../utils/locale';
import { Locales } from '@amzn/xb-hooks';

const idSeparator = '-';

const TopNavigationBar = (): JSX.Element => {
  const { formatMessage } = useIntl();

  const { locale, setLocale, supportedLocales } =
    useLocaleWrapper('TopNavigationBar');
  const supportedLocalesLookup = Locales.lookupFor(supportedLocales);

  const localeItems = getLocaleItems(
    locale.code,
    idSeparator,
    supportedLocales
  );

  const handleLocaleChange = (event: { detail: { id: any } }) =>
    getHandleLocaleChange(
      event,
      setLocale,
      supportedLocalesLookup,
      idSeparator
    );

  return (
    <TopNavigation
      //Caution: This selector is used by UI canaries. Any change to data-testid, will have to updated in canaries too.
      data-testid="header-localeMenu"
      identity={{
        href: '#',
        title: formatMessage(topNavigationMessages.title).toString(),
        logo: {
          src: aws_logo,
          alt: 'Logo',
        },
      }}
      utilities={[
        {
          type: 'menu-dropdown',
          text: locale.displayName,
          ariaLabel: 'Locales',
          onItemClick: handleLocaleChange,
          items: localeItems,
        },
      ]}
      className={styles.disabledLink}
    />
  );
};

export default TopNavigationBar;
